// extracted by mini-css-extract-plugin
export var divider = "_w3-0";